import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
var script = {
  name: 'Lazy',
  props: {
    rootMargin: {
      type: String,
      default: '0px'
    },
    threshold: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: '1px'
    },
    placeholderClass: {
      type: String,
      default: 'lazyload-placeholder'
    },
    onVisible: {
      type: Function,
      default: () => {}
    }
  },
  setup(_ref) {
    let {
      rootMargin,
      threshold,
      onVisible
    } = _ref;
    const placeholder = ref(null);
    const isVisible = ref(false);
    const {
      stop
    } = useIntersectionObserver(placeholder, _ref2 => {
      let [{
        isIntersecting
      }] = _ref2;
      isVisible.value = isIntersecting;
      if (isIntersecting) {
        stop();
        onVisible();
      }
    }, {
      rootMargin,
      threshold
    });
    return {
      placeholder,
      isVisible
    };
  },
  render(h) {
    if (this.isVisible) return this.$slots.default;
    return h('div', {
      ref: 'placeholder',
      class: this.placeholderClass,
      style: {
        height: this.height
      },
      attrs: this.$attrs
    });
  }
};
export { script as default };